module.exports = __webpack_public_path__ + "img/faq-white-icon.fa62dbba.png";